export const createBaseShape = (attrs) => {
  return Object.assign(
    {},
    {
      x: 0,
      y: 0,
      fill: 'white',
      name: 'shape',
      strokeScaleEnabled: false,
      enabledAnchors: [
        'top-left',
        'top-center',
        'top-right',
        'bottom-left',
        'bottom-center',
        'bottom-right',
        'middle-left',
        'middle-right'
      ],
      draggable: true,
      createdAt: Date.now()
    },
    attrs
  )
}



// WEBPACK FOOTER //
// ./src/components/schemaFonctionnel/helper/createBaseShape.js